import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { GoogleCalendarAuthError } from '../screens/googleCalendar/GoogleCalendarAuthError'

export const Route = createFileRoute('/googleCalendarAuthError')({
  component: GoogleCalendarAuthError,
  validateSearch: z.object({
    returnUrl: z.string().optional().catch(undefined),
  }),
})
